const STRENGTH_MATCHERS = [
    [/.{5,}/, 3],
    [/.{10,}/, 6],
    [/.{16,}/, 6],
    [/[a-z]/, 5],
    [/[A-Z]/, 5],
    [/\d+/, 5],
    [/(.*\d.*\d.*\d)/, 5],
    [/.[!@#$%^&*?_~-]/, 5],
    [/(.*[!@#$%^&*?_~-].*[!@#$%^&*?_~-])/, 5],
    [/([a-z].*[A-Z])|([A-Z].*[a-z])/, 2],
    [/([a-zA-Z0-9])/, 2],
    [/([a-zA-Z0-9].*[!@#$%^&*?_~-])|([!@#$%^&*?_~-].*[a-zA-Z0-9])/, 2]
];
export const passwordStrength = (password) => {
    if (password.length === 0) {
        return 0;
    }
    if (password.length < 8) {
        return 1;
    }
    if (password.match(/[a-z]/) == null ||
        password.match(/[A-Z]/) == null ||
        password.match(/\d/) == null) {
        return 2;
    }
    let strength = 3;
    STRENGTH_MATCHERS.forEach(([matcher, score]) => {
        if (password.match(matcher)) {
            strength += score;
        }
    });
    return Math.ceil(strength * (6 / 50));
};
